import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { layout, breakpoint } from '~/theme';

const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    column-gap: ${({ columnGap }) => layout[columnGap] ?? layout.gridGutter};
    row-gap: ${({ noRowGap, rowGap }) =>
        noRowGap ? '' : (layout[rowGap] ?? layout.gridGutter)};
    justify-items: ${({ justify }) => justify ?? `stretch`};
    align-items: ${({ align }) => align ?? `stretch`};

    @media (min-width: ${breakpoint.largePhone}) {
        column-gap: ${({ columnGapPhone }) =>
            layout[columnGapPhone] ?? layout.gridGutter};
        row-gap: ${({ noRowGap, rowGapPhone }) =>
            noRowGap ? '' : (layout[rowGapPhone] ?? layout.gridGutter)};
    }

    @media (min-width: ${breakpoint.largeTablet}) {
        column-gap: ${({ columnGapTablet }) =>
            layout[columnGapTablet] ?? layout.gridGutter};
        row-gap: ${({ noRowGap, rowGapTablet }) =>
            noRowGap ? '' : (layout[rowGapTablet] ?? layout.gridGutter)};
    }
`;

Row.propTypes = {
    justify: PropTypes.string,
    align: PropTypes.string,
    rowGapTablet: PropTypes.string,
    rowGapPhone: PropTypes.string,
    rowGap: PropTypes.string,
    columnGapTablet: PropTypes.string,
    columnGapPhone: PropTypes.string,
    columnGap: PropTypes.string,
    noRowGap: PropTypes.bool
};

export default Row;
